import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Brand } from '../interfaces/brand.interface';

const apiUrl = environment.apiUrl + 'guest/brands';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  brandObservable: Observable<Brand[]> | undefined;

  constructor(private http: HttpClient) {}

  getBrands() {
    if (!this.brandObservable) {
      this.brandObservable = this.http.get(apiUrl).pipe(
        map((res: any) => {
          return res.data;
        }),
        shareReplay(1)
      );
    }
    return this.brandObservable;
  }
}
